<template>
  <div class="finance-statements">
    <MoreTitle title="资产负债表" @click="goPage">
      <template v-slot:left>
        {{ $t('资产负债表') }}<span class="laste-report-icon">{{ lasteReportDate }}</span>
      </template>
    </MoreTitle>
    <div class="edge-padding">
      <RowInfo label="总资产">{{ $digitjs(financeData[formatA('totalAssets')]).convert() }}</RowInfo>
      <RowInfo label="总负债">{{ $digitjs(financeData[formatA('totalLiabilities')]).convert() }}</RowInfo>
      <RowInfo label="股东权益合计">{{ $digitjs(financeData[formatA('totalEquity')]).convert() }}</RowInfo>
    </div>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
export default {
  components: { RowInfo },
  props: ['reportTypeMap'],
  data() {
    return {
      financeData: {}
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    lasteReportDate() {
      const { reportType, endDate, balanceSheetDate } = this.financeData
      const year = this.$dayjs(endDate).format('YYYY')
      const isBefore = this.$dayjs(year + '/' + balanceSheetDate).isBefore(this.$dayjs(endDate))
      const sortYear = isBefore ? +year + 1 : +year
      return endDate && reportType
        ? `(${this.$t('$x年', {
            x: sortYear
          })}${this.$t(this.reportTypeMap[reportType])})`
        : ''
    }
  },
  created() {
    this.getFinanceData()
  },
  methods: {
    // A股字段特判
    formatA(val) {
      if (this.market === 'hs') {
        return (
          {
            totalAssets: 'totalAsset',
            totalLiabilities: 'totalLiab',
            totalEquity: 'totalSHEquity'
          }[val] ?? val
        )
      }

      return val
    },
    async getFinanceData() {
      const search = this.getSearchInfo()
      const res = await this.$post(search.api, search.params)
      this.financeData = res.data?.[0] ?? {}
    },
    getSearchInfo() {
      const searchInfo = {
        hk: {
          api: this.$api.f10.hk + '/finance/balance',
          params: {
            symbol: this.symbol
          }
        },
        hs: {
          api: this.$api.f10.hs + '/finance/balance',
          params: {
            symbol: this.symbol
          }
        },
        us: {
          api: this.$api.f10.us + '/finance/balance-basic',
          params: {
            symbol: this.symbol,
            reportTypes: ['Q1', 'Q6', 'Q9', 'FY'],
            reportSize: 1
          }
        }
      }
      return searchInfo[this.market]
    },
    goPage() {
      this.$router.push({
        path: '/f10/statements',
        query: {
          symbol: this.symbol,
          type: 'balance'
        }
      })
    }
  }
}
</script>
